var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevSlide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08768 11.8868L0.640378 3.43914C0.407779 3.20709 0.279824 2.89684 0.279824 2.56603C0.279824 2.23503 0.407779 1.92496 0.640378 1.69255L1.38058 0.952716C1.61281 0.719935 1.92324 0.591795 2.25406 0.591795C2.58487 0.591795 2.89494 0.719935 3.12735 0.952716L13.1852 11.0104C13.4185 11.2435 13.5463 11.5551 13.5454 11.8863C13.5463 12.2189 13.4187 12.5301 13.1852 12.7634L3.13671 22.8114C2.9043 23.0441 2.59423 23.1723 2.26323 23.1723C1.93242 23.1723 1.62235 23.0441 1.38975 22.8114L0.649736 22.0715C0.168203 21.59 0.168204 20.8061 0.649737 20.3248L9.08768 11.8868Z",
    fill: "#1D4EAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevSlide);
export default __webpack_public_path__ + "static/media/prevSlide.2e2f5e7efd90115338c5ae024e928fc4.svg";
export { ForwardRef as ReactComponent };